import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Guidance</h1>
      <ol>
        <li>Evidence sent via Hull MyScan will only go to Hull City Council. If you're not sure if we are your local authority, use the <a href="https://www.gov.uk/find-local-council">Find your local council too</a>, or <a href="https://hull.scanstation.lookinglocal.gov.uk/#/contacts">contact us</a>.</li>
        <li>The process is much quicker if you gather your evidence documents beforehand</li>
        <li>MyScan works best if you use your device to scan or take pictures of your evidence <b>before</b> you begin the submission process</li>
        <li>From the <a href="https://hull.scanstation.lookinglocal.gov.uk/#/home">Home</a> page, choose the service area you want to submit evidence for</li>
        <li>After selecting the service area, you may need to select the evidence type. Don’t worry if this step doesn’t exist. In some cases the evidence type will be automatically selected for you</li>
        <li>Fill in all required details in the form</li>
        <li>Select <code>Add Images</code> to upload your evidence. You can take a picture of your evidence or select an existing image from the photo gallery or other folder. These options depend on the device you use</li>
        <li>When you’re done, check there are no errors on the page and tap <code>Submit</code> to send your evidence to us</li>
        <li>If the submission was a success you will see a confirmation page and your reference number</li>
        <li>Store the submission reference number for your own records</li>
      </ol>

    </React.Fragment>
  );
};
